// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    updateCartLineWithResult as updateCartLineApi
} from "@insite/client-framework/Services/CartService";
import {
    UpdateCartLine,
    chain
} from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";

export const XngUpdateCartLine: typeof UpdateCartLine = async props => {
    const result = await updateCartLineApi(props.apiParameter);

    // XNG-Change:
    if (result.successful && result.result) {
        props.dispatch({
            type: "xCart/setAdjustedLineId",
            adjustedCartLineId: result.result.isQtyAdjusted ? result.result.id : undefined,
        });
    }
};

replaceInChain(chain, UpdateCartLine, XngUpdateCartLine);
